import { RootState } from "../../infrastructure/state/store";

export const activityHistoryFiltersSelector = (state: RootState) =>
  state.activityHistoryFilters.filters;
